import { GET_MEDIA_KEY } from '@/pages/AdvancedEditor/hooks';
import { uploadMedia } from '@/services/api';
import { useMutation, useQueryClient } from 'react-query';

export const useMediaUpload = () => {
    const queryClient = useQueryClient();

    return useMutation(uploadMedia, {
        onSuccess: () => {
            queryClient.invalidateQueries(GET_MEDIA_KEY);
        },
    });
};
